export default __webpack_public_path__ + "static/media/tradeKartLogo.420727d2.svg";